export default "__VITE_PUBLIC_ASSET__650d01ba__"